import { PathOptions } from "leaflet";

export const gasoduto_distribuicao_pe = (feature: any): PathOptions => {
  return {
    color: "#ffa500",
    weight: 2,
    opacity: 1,
  };
};
